import { irrigacao } from './genericos'

const TI = {
  area: '',
  numeroAnimais: '',
  dataInicio: '',
  tiposSistemas: [],
  outrosTipoSistema: '',
  especiesRacas: [],
  tiposAlimentacao: [],
  outroTipoAlimentacao: '',
  hasSuplementacaoMineral: '',
  possuiIrrigacao: '',
  irrigacao: {...irrigacao},
  financiamentos: [],
  outroFinanciamento: '',
  descricao: ''
}

export default TI



// WEBPACK FOOTER //
// ./src/libs/models/cadastro/praticas/TI.js